import basePath from "base_path";
import ActionTypes, {ProjectActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {Uuid} from "common/types";

export type IssueItem = {
  master_id: Uuid;
};

export type IssueEntry = string | IssueItem;

export type UpdatePortfolioReportIssuesAction = {
  type: ProjectActionTypes["PROJECT_UPDATE_PORTFOLIO_REPORT_ISSUES"]["SUCCESS"];
  payload: {
    id: ProjectId;
    bulk_report_settings: {
      used_issueset_master_id?: string;
      used_issue_names: IssueEntry[];
    };
  };
};

export default function projectUpdatePortfolioReportIssues(requestor) {
  return createReduxPromiseAction(
    ActionTypes.PROJECT_UPDATE_PORTFOLIO_REPORT_ISSUES,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      issueEntries: IssueEntry[],
    ) => {
      return requestor
        .patch(
          `${basePath}/organisation/${organisationId}/project/${projectId}/portfolio/issues`,
          {used_issue_names: issueEntries},
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
